export default __webpack_public_path__ + "static/media/bg.9e1488ac.jpg";